import { unsafeCSS as g, LitElement as b, html as y } from "lit";
import { property as l } from "lit/decorators.js";
(function() {
  var i = function(t, e) {
    var a = t.nodeType;
    if (a == 3)
      e.push(t.textContent.replace(/&/, "&amp;").replace(/</, "&lt;").replace(">", "&gt;"));
    else if (a == 1) {
      if (e.push("<", t.tagName), t.hasAttributes())
        for (var r = t.attributes, o = 0, n = r.length; o < n; ++o) {
          var c = r.item(o);
          e.push(" ", c.name, "='", c.value, "'");
        }
      if (t.hasChildNodes()) {
        e.push(">");
        for (var m = t.childNodes, o = 0, n = m.length; o < n; ++o)
          i(m.item(o), e);
        e.push("</", t.tagName, ">");
      } else
        e.push("/>");
    } else if (a == 8)
      e.push("<!--", t.nodeValue, "-->");
    else
      throw "Error serializing XML. Unhandled node of type: " + a;
  };
  "innerHTML" in SVGElement.prototype || Object.defineProperty(SVGElement.prototype, "innerHTML", {
    get: function() {
      for (var t = [], e = this.firstChild; e; )
        i(e, t), e = e.nextSibling;
      return t.join("");
    },
    set: function(t) {
      for (; this.firstChild; )
        this.removeChild(this.firstChild);
      try {
        var e = new DOMParser();
        e.async = !1;
        for (var a = "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>" + t + "</svg>", r = e.parseFromString(a, "text/xml").documentElement, o = r.firstChild; o; )
          this.appendChild(this.ownerDocument.importNode(o, !0)), o = o.nextSibling;
      } catch {
        throw new Error("Error parsing XML string");
      }
    }
  }), "innerSVG" in SVGElement.prototype || Object.defineProperty(SVGElement.prototype, "innerSVG", {
    get: function() {
      return this.innerHTML;
    },
    set: function(t) {
      this.innerHTML = t;
    }
  });
})();
const k = (i) => {
  class t extends i {
    constructor(...a) {
      super(...a), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (c) => c.href === this.fontLink
      ) === -1) {
        const c = document.createElement("link");
        c.href = this.fontLink, c.rel = "stylesheet", document.head.appendChild(c);
      }
    }
  }
  return t;
}, v = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.inline{display:inline}[hidden]{display:none!important}', x = g(v), h = "aileron-color-scheme", f = "aileron-color-scheme-change", z = (i) => {
  const e = class e extends i {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (r) => {
        r.detail ? this.setAttribute(h, r.detail) : this.removeAttribute(h);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        f,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const r = document.documentElement.getAttribute(
        h
      );
      r && this.setAttribute(h, r);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        f,
        this.handleSchemeSwitch
      );
    }
  };
  e.styles = [
    x,
    i.styles ?? []
  ];
  let t = e;
  return t;
}, u = z(k(b)), p = /* @__PURE__ */ new Map(), S = (i) => {
  const t = (e) => e.text();
  return p.has(i) || p.set(i, fetch(i).then(t).catch(() => {
  })), p.get(i);
}, C = ':host{display:flex}@keyframes spin{0%{transform:rotate(0)}50%{transform:rotate(359deg)}51%{transform:rotate(0)}75%{transform:rotate(134deg)}to{transform:rotate(359deg)}}:host{fill:currentcolor;color:inherit;display:inline-flex;pointer-events:none;vertical-align:text-top}:host(:not(:root)){overflow:hidden}:host([icon="action:loader"]) svg path:last-of-type{animation:spin .8s cubic-bezier(.17,.67,1,1) infinite;transform-origin:center}@media (forced-colors: active){.aileron-icon,:host{forced-color-adjust:auto}}#container{height:100%}img,svg,::slotted(*){vertical-align:top}svg path{fill:var(--icon-fill, currentcolor)}svg{display:inline}';
var E = Object.defineProperty, d = (i, t, e, a) => {
  for (var r = void 0, o = i.length - 1, n; o >= 0; o--)
    (n = i[o]) && (r = n(t, e, r) || r);
  return r && E(t, e, r), r;
};
const w = class w extends u {
  constructor() {
    super(...arguments), this.size = 16, this.filled = !1, this.outlined = !1;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-icon");
  }
  async fetchIcon(t) {
    if (!t || !t.includes(":"))
      return;
    const e = t.split(":")[0], a = t.split(":")[1], r = await S(
      `https://cdn.aa.com/aileron/icons/${e}${this.outlined ? "/outlined/" : this.filled ? "/filled/" : "/"}${a}.svg`
    ), n = new DOMParser().parseFromString(r, "text/html").body.querySelector("svg");
    return n == null || n.setAttribute("width", this.size.toString()), n == null || n.setAttribute("height", this.size.toString()), n == null || n.setAttribute("fill", "currentColor"), n == null || n.setAttribute("aria-hidden", "true"), n;
  }
  async willUpdate(t) {
    (t.has("icon") || t.has("filled") || t.has("outlined")) && (this.svg = await this.fetchIcon(this.icon)), t.has("size") && this.svg && (this.svg.setAttribute("width", this.size.toString()), this.svg.setAttribute("height", this.size.toString()));
  }
  render() {
    return y`${this.svg}`;
  }
};
w.styles = [u.styles || [], g(C)];
let s = w;
d([
  l()
], s.prototype, "icon");
d([
  l({
    type: Number,
    converter(i) {
      const t = ["16", "24", "32", "64"], e = (a, r) => a.reduce(
        (o, n) => Math.abs(n - r) < Math.abs(o - r) ? n : o
      );
      return i && !t.includes(i) ? e(t, i) : i;
    }
  })
], s.prototype, "size");
d([
  l({ type: Boolean })
], s.prototype, "filled");
d([
  l({ type: Boolean })
], s.prototype, "outlined");
d([
  l({ attribute: !1 })
], s.prototype, "svg");
try {
  customElements.define("adc-icon", s), console.warn(
    "@aileron/icon is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/icon"
  );
} catch {
}
function L(i) {
  try {
    customElements.define(`${i}-icon`, class extends s {
    });
  } catch {
  }
}
function F(i) {
  try {
    L(i);
  } catch {
  }
}
export {
  s as Icon,
  F as registerComponent,
  L as registerIcon
};
